//BACK-END: SERVICE LAYER PATTERN + CONTROLLER
//FRONT-END: REDUCERS PATTERN

import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import Global from "./WebAppsSharedStuffs/components/Global";
import GlobalModalsDisplayer from "./WebAppsSharedStuffs/components/GlobalModalsDisplayer";
import { ThemeProvider } from "./WebAppsSharedStuffs/context/ThemeProviderContext";
import { TranslationProvider } from "./WebAppsSharedStuffs/context/TranslationProviderContext";
import store from "./WebAppsSharedStuffs/redux";
import RouterPage from "./WebAppsSharedStuffs/router/Router";
import "./index.css";
import PiNetworkPriceUpdater from "./WebAppsSharedStuffs/components/PiNetworkPriceUpdater";
import VersionManager from "./WebAppsSharedStuffs/components/VersionManager";
// import * as Sentry from "@sentry/browser";
// import { browserTracingIntegration } from "@sentry/react";

// Sentry.init({
//   dsn: "https://a7376fa69c94fe3331a742becf574e76@o4506869972533248.ingest.us.sentry.io/4506870171959296",
//   integrations: [browserTracingIntegration()],
//   environment: process.env.NODE_ENV,
//   enableTracing: true,
// });
// const socketIoHandler = new SocketIOHandler();
// window.addEventListener("beforeunload", async () => {
//   const actualUser = ActualUser.getActualUser();
//   if (actualUser !== null) {
//     await ConnectService.connect().markAUserAsOffline(actualUser.userUid);
//   }
//   //SocketIOHandler.connect().sendData("offline", { actualUser });
//   console.log("closed");
// });
import DomainGuard from "./WebAppsSharedStuffs/components/DomainGuard";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <DomainGuard>
      <VersionManager />
      <PiNetworkPriceUpdater/>
      <ThemeProvider>
        <TranslationProvider>
          <BrowserRouter>
            <Global>
              <RouterPage></RouterPage>
              <GlobalModalsDisplayer />
            </Global>
          </BrowserRouter>
        </TranslationProvider>
      </ThemeProvider>
    </DomainGuard>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
if ("serviceWorker" in navigator) {
  window.addEventListener("load", function () {
    navigator.serviceWorker.register("/service-workers.js").then(
      function (registration) {
        console.log(
          "ServiceWorker registration successful with scope: ",
          registration.scope
        );
      },
      function (err) {
        console.log("ServiceWorker registration failed: ", err);
      }
    );
    //navigator.serviceWorker.unregister();
  });
}
